
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watchlists/[watchlist]",
      function () {
        return require("private-next-pages/watchlists/[watchlist].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watchlists/[watchlist]"])
      });
    }
  